export enum OrderState {
  STATE_CART = 'cart',
  STATE_NEW = 'new',
  STATE_CANCELLED = 'cancelled',
  STATE_FULFILLED = 'fulfilled',
}
